var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('van-area',{attrs:{"title":"地区选择","area-list":_vm.areaList},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }